import BaseBlock from "./BaseBlock";
import Swal from "sweetalert2";

class Vote extends BaseBlock {

    init() {
        const titleEl = this.block.querySelector(".vote-title");
        if (titleEl) {
            titleEl.prepend((this.index + 1) + ". ");
        }
        this.block.querySelector(".vote-button:enabled")
            .addEventListener("click", this.onVoteButtonClick.bind(this));
    }
    /**
     *
     * @param {Event} e
     */
    onVoteButtonClick(e) {
        /**
         *
         * @type {HTMLButtonElement}
         */
        const $this = e.currentTarget;
        const icon = $this.querySelector("i");
        const voteResult = $this.previousElementSibling;
        const data = new FormData();
        const blockId = $this.getAttribute('data-block-id');
        /**
         * @type {HTMLInputElement}
         */
        const nonceEl = document.querySelector(`input#vote_wp_nonce_${blockId}`)

        data.append("action", "Vote/AddBlock");
        data.append("nonce", nonceEl.value);
        data.append("blockID", $this.getAttribute('data-block-id'));
        data.append("postID", $this.getAttribute('data-post-id'));
        data.append("votesInitial", $this.getAttribute('data-votes-initial'));

        $this.disabled = true;
        icon.classList.remove("fa-thumbs-o-up");
        icon.classList.add("fa-circle-o-notch", "fa-spin");

        window.fetch(thee.url.ajax, {
            body: data,
            method: "post"
        }).then(async (response) => {

            icon.classList.remove("fa-circle-o-notch", "fa-spin");
            icon.classList.add('fa-thumbs-o-up');

            const result = await response.json();
            $this.removeEventListener("click", this.onVoteButtonClick.bind(this));

            if (result.errorMessage) {
                await this.displayError(result.errorMessage);
            }
            else {
                voteResult.innerHTML = result.data.html;
            }
        });
    }

    /**
     * @param {string} message
     */
    async displayError(message) {
        switch (message) {
            case 'error: voted block':
                await Swal.fire({
                    icon: 'error',
                    title: 'It looks like you voted for this contestant in the last 24 hours.',
                    text: 'Please come back tomorrow to vote again.'
                });
                break;

            case 'error: daily max':
                await Swal.fire({
                    icon: 'error',
                    title: 'It looks like you voted the maximum allowed times in the last 24 hours.',
                    text: 'Please come back tomorrow to continue voting for your favorite contestants.'
                });
                break;
        }
    }
}

export default Vote;
